export default __webpack_public_path__ + "static/media/Ajux_loader_full.6281c6f4.gif";